import { render } from "./SignIn.vue?vue&type=template&id=a201bda6&scoped=true"
import script from "./SignIn.vue?vue&type=script&lang=js"
export * from "./SignIn.vue?vue&type=script&lang=js"

import "./SignIn.vue?vue&type=style&index=0&id=a201bda6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a201bda6"

export default script